<template>
  <div>
    <div class="field is-grouped is-grouped-centered">
      <div class="control">
        <button class="button is-success" @click.prevent="done">
          Done
        </button>
      </div>
    </div>
    <div class="level">
      <div class="level-item">
        <b-upload v-model="dropFiles" multiple drag-drop position="is-centered">
          <section class="section">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="cloud-upload-alt" size="is-large">
                </b-icon>
              </p>
              <p>Drop files here or click to upload</p>
            </div>
          </section>
        </b-upload>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'file-upload',
  props: ['value'],
  computed: {
    dropFiles: {
      get() {
        return this.value;
      },
      set(file) {
        this.dropFiles.push(file);
        this.$emit('input', this.dropFiles);
      },
    },
  },
  methods: {
    done() {
      this.$emit('done');
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/FileUpload.vue